import * as angular from 'angular';
export default angular.module('obto.http.service', []).config(function ($httpProvider) {
    $httpProvider.interceptors.push(function () {
        return {
            request: function (config) {
                // Modify or log the request as needed
                console.log('Request intercepted:', config);
                return config;
            },
            response: function (response) {
                // Modify or log the response as needed
                console.log('Response intercepted:', response);
                return response;
            },
        };
    });
}).factory('angularHttpService', ['$http', function ($http) {
    return {
        // Add other HTTP methods as needed
        // Alternatively, you can also use $http like this:
        get: (url, config) => {
            return $http.get(url, config);
        },
        post: (url, data, config) => {
            return $http.post(url, data, config);
        },
        // Add other HTTP methods using $http
    };
}]);